import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-loop",
  "use": "icon-loop-usage",
  "viewBox": "0 0 26 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 25\" id=\"icon-loop\"><path d=\"M2.306 10.432c0-4.954 4.03-8.98 8.978-8.98 4.954 0 8.979 4.031 8.979 8.98 0 4.948-4.025 8.984-8.979 8.984-4.948 0-8.978-4.03-8.978-8.984zm22.818 12.802l-5.953-5.953a10.403 10.403 0 0 0 2.564-6.85c0-5.763-4.688-10.445-10.445-10.445C5.527-.014.844 4.674.844 10.432c0 5.757 4.688 10.445 10.446 10.445 2.618 0 5.013-.967 6.85-2.564l5.952 5.953a.738.738 0 0 0 .516.218.734.734 0 0 0 .516-1.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol